import { memo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import styled from 'styled-components';
import { MICROCOPY_SIZE } from 'HubStyleTokens/sizes';
import { SLINKY } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIFormLabel = styled(UIFormLabel).withConfig({
  displayName: "CallDuration__StyledUIFormLabel",
  componentId: "sc-1u2oquk-0"
})(["&&{color:", ";font-size:", ";font-weight:normal;}"], SLINKY, MICROCOPY_SIZE);
function CallDuration({
  callInProgress,
  duration
}) {
  const labelKey = I18n.text(`conversations-calling-message.timeline-call-metadata.call-duration.label`);
  let messageKey = `conversations-calling-message.timeline-call-metadata.call-duration.value`;
  let minutes;
  let seconds;
  if (typeof duration === 'number') {
    const momentDuration = I18n.moment.duration(duration, 'milliseconds');
    minutes = momentDuration.get('minutes');
    seconds = momentDuration.get('seconds');
    if (minutes && !seconds) {
      messageKey = `conversations-calling-message.timeline-call-metadata.call-duration.minutes`;
    } else if (!minutes && seconds) {
      messageKey = `conversations-calling-message.timeline-call-metadata.call-duration.seconds`;
    }
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    className: "m-top-0 p-top-1 p-bottom-4",
    "data-test-id": "call-duration",
    FormLabel: StyledUIFormLabel,
    label: labelKey,
    children: callInProgress ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-calling-message.timeline-call-metadata.call-duration.processing"
      }), /*#__PURE__*/_jsx(UIHelpIcon, {
        className: "m-left-1",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.call-duration.processing-tooltip"
        })
      })]
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: messageKey,
      options: {
        minutes,
        seconds
      }
    })
  });
}
export default /*#__PURE__*/memo(CallDuration);